document.addEventListener("scroll", function() {
    var scrollPosition = window.pageYOffset;
    document.querySelector(".parallax-image").style.transform = "translateY(" + scrollPosition * 0.5 + "px)";
});

//# sourceMappingURL=path0.2c6ee080.js.map
